function Dialog({ children, open, setOpen }) {
    return (
        <dialog
            open={typeof open === 'boolean' ? open : true}
            className="fixed top-0 left-0 right-0 bottom-0 z-50 w-full h-full flex flex-col items-center justify-center bg-purple-dark/80 backdrop-blur-sm"
            onClick={() => {
                setOpen ? setOpen(false) : null;
            }}>
            {children}
        </dialog>
    );
}

export default Dialog;
